<script lang="ts" setup>
const { isUsers } = useUser()
const { params, query } = useRoute()
const { collection, identifier } = params
const pb = useNuxtApp().$pb
const fullCollection = GetCollection(collection)

const { data: review } = await useAsyncData(
  `review-${identifier}`,
  async () => {
    if (collection !== 'reviews' || !identifier) {
      return null
    }
    if (query?.type === 'gbf') {
      return pb.collection('gbfReviews').getOne<AllReview>(identifier)
    }

    return pb.collection('allReviews').getOne<AllReview>(identifier)
  },
)

if (review.value) {
  getHead(review.value)
}

onMounted(async () => {
  if (collection === 'reviews' && identifier && review.value) {
    if (query?.type === 'gbf') {
      navigateTo(`/reviews?review=${encodeURIComponent(identifier)}&type=gbf`)
      return
    }

    const col = GetCollection(review.value.reviewedEntity)
    const relatedRecord = await pb.collection(col.collection).getOne(review.value.reviewedId)
    const route = getPublicRoute(col.collection, relatedRecord)

    if (route) {
      navigateTo(`${route}?review=${identifier}`)
    }
  }
})

const { data, status, error, refresh } = await useAsyncData(
  `sin-${collection}-${identifier}`,
  async () => {
    if (collection === 'reviews') return null
    const col = GetCollection(collection)

    if (!col?.identifier)
      return null
    const filter = pb.filter(`${col.identifier} = {:id}`, { id: identifier })
    const record = await pb.collection(col?.pub?.collection ?? col.collection).getFirstListItem(filter, { expand: col?.pub?.expand ?? '' })
    if (isUsers(record?.value?.id, col.collection)) {
      record.isUsers = true
    }
    return record ?? null
  },
)

function getHead(_data: AllReview) {
  if (!_data && collection !== 'reviews' && !identifier) return
  useSeoMeta({
    title: _data.entityName ? `Review for ${_data.entityName ?? ''}` : 'Review',
    ogTitle: _data.entityName ? `Review for ${_data.entityName ?? ''}` : 'Review',
    description: _data.review ? _data.review : 'Review',
    ogDescription: _data.review ? _data.review : 'Review',
    twitterTitle: _data.entityName ? `Review for ${_data.entityName ?? ''}` : 'Review',
    twitterDescription: _data.review ? _data.review : 'Review',
    // ogImage: 'https://example.com/image.png',
    // twitterCard: 'summary_large_image',
  })

  defineOgImageComponent('Review', {
    title: `Review`,
    backgroundColor: 'bg-slate-100',
    review: _data.review,
    businessName: _data.entityName,
  })
}
</script>

<template>
  <div>
    <component
      :is="fullCollection?.pub?.viewComponent"
      v-if="data"
      :data="data"
    />
    <transition
      name="fade"
      mode="out-in"
    >
      <div
        v-if="data?.isUsers"
        class="fixed bottom-3 right-3"
      >
        <UButton
          variant="solid"
          color="primary"
          size="xl"
          icon="ri:edit-box-line"
          to="/dashboard/"
        >
          Edit
        </UButton>
      </div>
    </transition>
  </div>
</template>
